import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  themeMode: "light",
  collapseOpen: window.localStorage.collapseOpen
    ? JSON.parse(window.localStorage.collapseOpen)
    : {},
  sortModel: {},
  searchText: {},
  selectedDate: {},
  globalMessage: {},
  selectedProduct: {},
  selectedCategory: {},
};
export const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    themeMode: (state, action) => {
      state.themeMode = action.payload;
    },
    setGlobalMessage: (state, action) => {
      const { message } = action.payload;
      state.globalMessage = message;
    },
    setCollapseOpen: (state, action) => {
      const { index, isOpen } = action.payload;
      state.collapseOpen[index] = isOpen;
    },
    setSelectedCategory: (state, action) => {
      const { page, value, id } = action.payload;
      if (!state.selectedCategory[page]?.[id]) {
        state.selectedCategory[page] = {
          ...state.selectedCategory[page],
          [id]: {},
        };
      }
      state.selectedCategory[page][id] = value;
    },
    setSortModel: (state, action) => {
      const { page, value } = action.payload;
      state.sortModel[page] = value;
    },
    setSearchText: (state, action) => {
      const { page, value } = action.payload;
      state.searchText[page] = value;
    },
    resetDataTable: (state, action) => {
      state.searchText = {};
      state.sortModel = {};
      state.selectedDate = {};
    },
    setSelectedDate: (state, action) => {
      const { page, value } = action.payload;
      state.selectedDate[page] = value;
    },
    setSelectedProduct: (state, action) => {
      const { page, value } = action.payload;
      state.selectedProduct[page] = value;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  themeMode,
  setSortModel,
  setCollapseOpen,
  setSearchText,
  resetDataTable,
  setSelectedDate,
  setGlobalMessage,
  setSelectedProduct,
  setSelectedCategory,
} = systemSlice.actions;

export default systemSlice.reducer;
